module.exports = __webpack_public_path__ + "static/box_2-84867c0f15edebb1f69d1c78116c9453.png";